import React, { useState } from "react";

export const LocalizationContext = React.createContext({
    localizationData: {
        cultureCode: "",
        idLanguage: "",
        mainTitle: "",
        payOff: "",
        actionConfigure: "",
        actionReview: "",
        actionSend: "",
        actionStart: "",
        configureTitle: "",
        configureSection1Title: "",
        configureSection1Text: "",
        configureSection2Title: "",
        configureSection2Text: "",
        interior: "",
        moodClassic: "",
        moodContemporary: "",
        buttonSelected: "",
        buttonSelect: "",
        recapTitle: "",
        buttonBack: "",
        buttonSend: "",
        contactTitle: "",
        contactSubTitle: "",
        buttonContinue: "",
        alertUpdated: "",
        buttonConfirm: "",
        lateralBarTitle: "",
        toolTipConfirm: "",
        toolTipRecap: "",
        toolTipReset: "",
        formName: "",
        formSurname: "",
        formAddress: "",
        formCity: "",
        formZipCode: "",
        formCountry: "",
        formProvince: "",
        formEmailAddress: "",
        formPhoneNumber: "",
        formRequest: "",
        formFlagGdprCompliance: "",
        formFlagGdprCompliance2: "",
        formFlagGdprComplianceLink: "",
        formCookies: "",
        formFlagGdprMarketing: "",
        formFlagGdprFraud: "",
        formFlagGdprProfiling: "",
        formAlertFlagCompliance: "",
        formAlertEmailNotValid: "",
        formAlertMandatoryField: "",
        flagYes: "",
        flagNo: "",
        footerRow1: "",
        footerRow2: "",
        footerPolicy: "",
        footerCookies: "",
        landscapeMode: "",
        landscapeMode2: "",
        loadingStart: "",
        loadingWait: "",
        loadingSend: "",
        headerBarTitle: "",
        congratulations: "",
        thanksTitle: "",
        thanksMessage: "",
        actionStartNew: "",
        actionVisitWebsite: ""
    },
    updateLocalizationData: () => { },
});

export const LocalizationContextProvider = (props) => {
    const [localizationData, setLocalizationData] = useState({
        cultureCode: "",
        idLanguage: "",
        mainTitle: "",
        payOff: "",
        actionConfigure: "",
        actionReview: "",
        actionSend: "",
        actionStart: "",
        configureTitle: "",
        configureSection1Title: "",
        configureSection1Text: "",
        configureSection2Title: "",
        configureSection2Text: "",
        interior: "",
        moodClassic: "",
        moodContemporary: "",
        buttonSelected: "",
        buttonSelect: "",
        recapTitle: "",
        buttonBack: "",
        buttonSend: "",
        contactTitle: "",
        contactSubTitle: "",
        buttonContinue: "",
        alertUpdated: "",
        buttonConfirm: "",
        lateralBarTitle: "",
        toolTipConfirm: "",
        toolTipRecap: "",
        toolTipReset: "",
        formName: "",
        formSurname: "",
        formAddress: "",
        formCity: "",
        formZipCode: "",
        formCountry: "",
        formProvince: "",
        formEmailAddress: "",
        formPhoneNumber: "",
        formRequest: "",
        formFlagGdprCompliance: "",
        formFlagGdprCompliance2: "",
        formFlagGdprComplianceLink: "",
        formCookies: "",
        formFlagGdprMarketing: "",
        formFlagGdprFraud: "",
        formFlagGdprProfiling: "",
        formAlertFlagCompliance: "",
        formAlertEmailNotValid: "",
        formAlertMandatoryField: "",
        flagYes: "",
        flagNo: "",
        footerRow1: "",
        footerRow2: "",
        footerPolicy: "",
        footerCookies: "",
        landscapeMode: "",
        landscapeMode2: "",
        loadingStart: "",
        loadingWait: "",
        loadingSend: "",
        headerBarTitle: "",
        congratulations: "",
        thanksTitle: "",
        thanksMessage: "",
        actionStartNew: "",
        actionVisitWebsite: ""
    });


    const UpdateLocalizationData = (localizationData) => {
        setLocalizationData(localizationData);
    };

    return (
        <LocalizationContext.Provider value={{
            localizationData: localizationData,
            updateLocalizationData: UpdateLocalizationData,
        }}>
            {props.children}
        </LocalizationContext.Provider>
    );
};

export default LocalizationContext;
